export const isSomething = <TValue>(
    value: TValue | null | undefined
): value is TValue => {
    return typeof value !== 'undefined' && value !== null;
};
